import type { PlayerHistoryEntryDto } from '@/api/dto';
import { MiniRoute } from '@/components/round/MiniRoute';
import { PlaceBadge } from '@/components/ui/PlaceBadge';
import { Card } from '@/components/ui/Card';
import { ru } from '@/i18n/ru';
import styles from './RecentGames.module.css';

function fmtDate(when: string): string {
  return new Date(when)
    .toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })
    .replace('.', '');
}

interface RecentGamesProps {
  history: PlayerHistoryEntryDto[];
}

export function RecentGames({ history }: RecentGamesProps) {
  const entries = history.slice(0, 5);
  return (
    <Card className={styles.card}>
      <div className={styles.title}>{ru.recentGames.title}</div>
      <div className={styles.list}>
        {entries.map((entry, i) => (
          <div key={i} className={styles.row}>
            <MiniRoute letters={entry.letters} />
            <div className={styles.meta}>
              <span className={styles.mode}>{entry.mode}</span>
              <span className={styles.when}>{fmtDate(entry.when)}</span>
            </div>
            <div className={styles.result}>
              <PlaceBadge place={entry.place} />
              <span className={styles.score}>{entry.score}</span>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
